import { render, staticRenderFns } from "./JxCount.vue?vue&type=template&id=5065483a&scoped=true"
import script from "./JxCount.vue?vue&type=script&lang=js"
export * from "./JxCount.vue?vue&type=script&lang=js"
import style0 from "./JxCount.vue?vue&type=style&index=0&id=5065483a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5065483a",
  null
  
)

export default component.exports